import React from "react";
import { Navigate } from "react-router-dom";
function AdminProtected({ access, children }) {
  const token = localStorage.getItem("superadmin");
  return token === "is-super-admin" ? (
    access === false ? (
      <Navigate to="/home" />
    ) : (
      children
    )
  ) : (
    <Navigate to="/home" />
  );
}

export default AdminProtected;
